export default __webpack_public_path__ + "static/banner-software-development-ezgif.com-avif-to-jpg-converter-eddf36c2eda32a8b7c90ffe37efdc09d.jpg";